import type { ReactNode } from "react";

/**
 * The prototype's `data-tooltip` pattern: a focusable label with a CSS-rendered
 * bubble. `tabIndex` keeps it reachable by keyboard.
 */
export function TooltipLabel({
  tooltip,
  className = "micro-label",
  id,
  children,
}: {
  tooltip: string;
  className?: string;
  id?: string;
  children: ReactNode;
}) {
  return (
    <span id={id} className={`${className} tooltip-label`} tabIndex={0} data-tooltip={tooltip}>
      {children}
    </span>
  );
}
